import { FC } from 'react'

import {
  CampaignUpsellProps,
  getUpsellVariant,
  renderButton,
  upsellConfig,
} from './helpers'

import {
  CampaignUpsellButtonsContainer,
  CampaignUpsellTextContainer,
  CampaignUpsellTitle,
  Container,
  CampaignUpsellText,
} from './styles'

export const CampaignUpsellCard: FC<CampaignUpsellProps> = (props) => {
  const variant = getUpsellVariant(props.placementsCount)

  const config = upsellConfig[variant]

  const shouldShowButton = config.shouldShowButton
    ? config.shouldShowButton(props)
    : true

  return (
    <Container $highlighted={config.isHighlighted}>
      <CampaignUpsellTextContainer>
        <CampaignUpsellTitle>{config.title}</CampaignUpsellTitle>
        <CampaignUpsellText>{config.description}</CampaignUpsellText>
      </CampaignUpsellTextContainer>

      {shouldShowButton && (
        <CampaignUpsellButtonsContainer>
          {renderButton(config, props)}
        </CampaignUpsellButtonsContainer>
      )}
    </Container>
  )
}
